import { LoaderCircleIcon } from "lucide-react";
import type { ComponentPropsWithRef } from "react";
import { cn } from "@/lib/utils";

function Spinner({ className, ...props }: ComponentPropsWithRef<"svg">) {
  return (
    <LoaderCircleIcon
      aria-label="Loading"
      className={cn("size-4 animate-spin", className)}
      role="status"
      {...props}
    />
  );
}

export { Spinner };
